import CreateAssociationTypeField from './CreateAssociationTypeField.component';

export default CreateAssociationTypeField;